import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';


@Component({
  selector: 'page-stok-hareketleri',
  templateUrl: 'stok-hareketleri.html',
})
export class StokHareketleriPage {
  stok: any = { ID: "" };
  hareketlistesi = [];
  constructor(public navCtrl: NavController,
    public bllOrtak: BllOrtak,
    public viewCtrl:ViewController,
    public navParams: NavParams) {
    if (navParams.get("stok") != null) {
      this.stok = navParams.get("stok");
      var formdata = new FormData();
      formdata.append("stokid", this.stok.ID);
      this.bllOrtak.islem(formdata, "StokHareketleri", "", true).then(a => {
        var sonuc = <any>a;
        this.hareketlistesi = sonuc.SonucObject;
       
      })
    }
  }
kapat()
{
  this.viewCtrl.dismiss();
}


}



// WEBPACK FOOTER //
// ./src/pages/StokIslemleri/stok-hareketleri/stok-hareketleri.ts